const menuButton = document.querySelector("[data-menu-button]");
const mobileMenu = document.querySelector("[data-mobile-menu]");

if (menuButton && mobileMenu) {
  menuButton.addEventListener("click", () => {
    const isOpen = mobileMenu.classList.toggle("hidden") === false;
    menuButton.setAttribute("aria-expanded", String(isOpen));
  });
}

const reviewRows = document.querySelectorAll("[data-review-row]");
const reviews = [
  {
    name: "Joyce C.",
    source: "Google",
    text: "My truck was stolen once. With Cube I know where it is at all times and would purchase again."
  },
  {
    name: "Erik P.",
    source: "Google",
    text: "Works perfectly. The battery barely moved after weeks of use and location accuracy has been spot on."
  },
  {
    name: "Nick W.",
    source: "Amazon",
    text: "Very strong magnet and multiple ways to find the tracker when you need it."
  },
  {
    name: "Debra P.",
    source: "Customer review",
    text: "I bought this for my son's puppy while she learns her boundaries. It gives us peace of mind."
  }
];

const starRatingUrl = window.CubeTheme?.assets?.starRating || "5stars.png";
const stars = `<img src="${starRatingUrl}" class="h-4 w-auto" alt="5 star rating">`;

const reviewCard = (review) => `
  <article class="mx-3 w-[300px] shrink-0 rounded-lg border border-slate-200 bg-white p-5 shadow-sm sm:w-[380px]">
    <div class="mb-3 flex items-center justify-between gap-3">
      <div>
        <p class="text-sm font-bold text-cube-ink">${review.name}</p>
        <p class="text-xs text-slate-500">${review.source}</p>
      </div>
      ${stars}
    </div>
    <p class="text-sm leading-6 text-slate-700">${review.text}</p>
  </article>
`;

reviewRows.forEach((row) => {
  const items = [...reviews, ...reviews].map(reviewCard).join("");
  row.innerHTML = items;
});

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-gallery-src]");
  if (!button) return;

  const galleryRoot = button.closest("[data-gallery]") || document;
  const galleryImage = galleryRoot.querySelector("[data-gallery-image]");

  if (!galleryImage || !button.dataset.gallerySrc) return;

  galleryImage.setAttribute("src", button.dataset.gallerySrc);
  galleryImage.setAttribute("alt", button.dataset.galleryAlt || "Cube GPS Pro tracker");
  if (button.dataset.gallerySrcset) {
    galleryImage.setAttribute("srcset", button.dataset.gallerySrcset);
  } else {
    galleryImage.removeAttribute("srcset");
  }

  galleryRoot.querySelectorAll("[data-gallery-src]").forEach((item) => item.setAttribute("aria-pressed", "false"));
  button.setAttribute("aria-pressed", "true");
});
